// Formato de moneda SOLO para la capa de UI. Pesos uruguayos, sin decimales:
//   1234 -> "$ 1.234"

const fmt = new Intl.NumberFormat("es-UY", { maximumFractionDigits: 0 });

export function formatearPesos(n: number): string {
  return `$ ${fmt.format(Math.round(n))}`;
}
